export const ORDER_PRICE_TYPE_ENUM = {
    10: "Фиксированная цена",
    20: "Аукцион",
    30: "Предложенная цена",
};

export const forwardingUrl = () =>
    location.hostname === "prod.integration.cargorun.ru" || location.hostname === "delko.integration.cargorun.ru"
        ? "https://test.web.forwarding.nv.smprojects.ru"
        : process.env.FORWARDING_URL;
